module.exports = __webpack_public_path__ + "static/media/logo.1b8dbfb7.svg";